// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class BusinessLabel {
  public id!: string;

  public name!: string;

  public code!: string;

  public static fromDto(dto: any): BusinessLabel {
    const businessLabel: BusinessLabel = new BusinessLabel();
    businessLabel.id = dto.id;
    businessLabel.name = dto.name;
    businessLabel.code = dto.code;
    return businessLabel;
  }
}
